import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import Summit from './Summit.js';
import SummitPayment from './SummitPayment.js';
import { translate } from 'react-i18next';

import PromoCodeContainer from './PromoCodeContainer.js';

let cancelToken;

class SummitContainer extends Component {

    constructor(props) {
        super(props);
        this.state = this.getInitState(props);
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        $(window).off("resize", this.resize);
    }

    componentDidMount() {
        $(window).resize(this.resize);
        this.resize();
        this.reload();
        // Api Prueba Conekta  publica
        //window.Conekta.setPublicKey("key_DvRQxiTH737NrqaDr9TexLQ");

        // Api Producion Conekta publica
        window.Conekta.setPublicKey("key_eShUJ6yB1yxTgRqyajShWew");


    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.correo !== prevState.correo) {
            this.setState({
                is_errorcheck: false
            },);
        }
    }

    getInitState = (props) => {
        return {
            divButtonPay: false,
            infoPago: false,
            token_conekta: '',
            proccesPay: false,
            infoPromocode: {
                porcentaje_descuento: 0,
                descuento_aplicado: 0
            },
            showCommentRefence: false,
            sectionRedSocial: false,
            statusForm: true,
            statusButton: true,
            disabled: false,
            successUserSuscribe: false,
            errorUserSuscribe: false,
            buttonSubmit: false,
            userExist: false,
            msgErrorPay: '',
            nameClient: '',
            emailClient: '',
            // info cliente
            nombre: '',
            lastname: '',
            celular: '',
            edad: '',
            genero: '',
            correo: '',
            ciudad: null,
            empresa: '',
            tipo_empresa: 0,
            puesto: '',
            como_se_entero: '',
            como_se_entero_descrp: '',
            direccion: '',
            disponibilidad: 0,
            plan: 0,
            busines: "",
            business: [],
            redSocial: "",
            promoCode: "",
            promocodeError: "",
            centro: [],
            centro_id: 26,
            centro_razonSocial: 1,
            setPublicKey: "",
            plan: "",
            plan_id: "",
            estados: [],
            estados_id: "",
            ciudades: null,
            ciudad_id: "",
            is_pay: false,
            porcentaje_summit: null,
            is_errorcheck: false,
            isFree: false,
            ispayfree: false,
        };
    }

    reload = () => {
        this.getBusiness({
            token_id: this.props.getTokenId()
        });

        this.getCentroId({
            token_id: this.props.getTokenId(),
            centro_id: this.state.centro_id
        });

        this.getEstados({
            token_id: this.props.getTokenId()
        });

    }

    resize = () => {
        $('#content').css({
            paddingTop: this.props.getNavbarHeight()
        });
    }

    getBusiness = (params) => {
        this.props.post(
            "/getBusiness",
            params,
            (response) => this.didGetBusiness(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    getConneckatKey = (params) => {
        this.props.post(
            "/getConnekta",
            params,
            (response) => this.didGetConekta(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    getcheckUser = (params) => {
        this.props.post(
            "/checkUser",
            params,
            (response) => this.didGetCheckUser(response),
            (error) => this.didGetErrorCheck(error),
            cancelToken
        );
    }

    getcheckUserFree = (params) => {
        this.props.post(
            "/checkUser",
            params,
            (response) => this.didGetCheckUserFree(response),
            (error) => this.didGetErrorCheck(error),
            cancelToken
        );
    }

    didGetCheckUserFree = (response) => {
        this.registarUsuariosFree({
            nombre: this.state.nombre + ' ' + this.state.lastname,
            centro_id: this.state.centro_id,
            correo: this.state.correo,
            edad: this.state.edad,
            genero: this.state.genero,
            celular: this.state.celular,
            ciudad: this.state.ciudad_id,
            empresa: this.state.empresa,
            tipo_empresa: this.state.tipo_empresa,
            puesto: this.state.puesto,
            como_se_entero: this.state.como_se_entero,
            plan_id: this.state.plan_id,
            red_social: this.state.redSocial,
            token_conekta: this.state.token_conekta,
            business_id: this.state.busines,
            promoCode: this.state.promoCode,
            token_id: this.props.getTokenId(),
        });
    }

    getCentroId = (params) => {
        this.props.post(
            "/getCentro",
            params,
            (response) => this.didGetCentroInfo(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    getEstados = (params) => {
        this.props.post(
            "/getEstados",
            params,
            (response) => this.didListEstados(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    getCuidades = (params) => {
        this.props.post(
            "/getCuidades",
            params,
            (response) => this.didGetListCuidades(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    didListEstados = (response) => {
        this.setState({ estados: response });
    }

    didGetListCuidades = (response) => {
        //console.log("response", response);
        this.setState({ ciudades: response });
    }

    didGetConekta = (response) => {
        this.setState({ setPublicKey: response.conekta_public_key });
    }

    didGetCheckUser = (response) => {
        this.setState({ is_pay: true });
    }

    didGetErrorCheck = (error) => {
        this.setState({ 
            is_errorcheck: true,
            ispayfree: false
        });
    }

    didGetError = (error) => {

    }

    didGetBusiness = (response) => {
        this.setState({ business: response });
    }

    didGetCentroInfo = (response) => {
        this.setState({
            centro: response,
            centro_razonSocial: response.centro_razonsociale_id
        });

        this.getConneckatKey({
            token_id: this.props.getTokenId(),
            razon_social_id: response.centro_razonsociale_id
        });
    }

    handleCentroChange = (event) => {
        this.setState({ centro_id: event.target.value });
    }

    handlebusinesChange = (event) => {
        this.setState({ busines: event.target.value });
    }

    handleEstadosChange = (event) => {
        this.setState({ estados_id: event.target.value });
        this.getCuidades({
            token_id: this.props.getTokenId(),
            estado_id: event.target.value
        });
    }

    handleCuidadesListChange = (event) => {
        this.setState({ ciudad_id: event.target.value });
    }

    handleChangeEvent = (event) => {
        this.setState({ como_se_entero: event.target.value });
    }

    handlePlanChanged = (event) => {
        this.setState({ plan_id: event.target.value });
    }

    handleChanegeevento_descrp = (event) => {
        this.setState({ como_se_entero_descrp: event.target.value });
    }

    handleChangePuesto = (event) => {
        this.setState({ puesto: event.target.value });
    }

    handleChanegetp_empresa = (event) => {
        this.setState({ tipo_empresa: event.target.value });
    }

    handleChanegeEmpresa = (event) => {
        this.setState({ empresa: event.target.value });
    }

    handleChanegeCiudad = (event) => {
        this.setState({ ciudad: event.target.value });
    }

    handleChanegeGenero = (event) => {
        this.setState({ genero: event.target.value });
    }

    handleChanegeEdad = (event) => {
        this.setState({ edad: event.target.value });
    }

    handleChanegeCelular = (event) => {
        this.setState({ celular: event.target.value });
    }

    handleChanegeCorreo = (event) => {
        this.setState({ correo: event.target.value });
    }

    handleChanegeName = (event) => {
        this.setState({ nombre: event.target.value });
    }

    handleChanegeLastName = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handleChangeSocial = (event) => {
        this.setState({ redSocial: event.target.value });
    }

    handleChangePromocode = (event) => {
        this.setState({ promoCode: event.target.value });
    }

    handleClearPromocode = () => {
        this.setState({ promocodeError: "" });
    }

    didPayInvoice = (response, msg) => {
        alert(response);
    }

    pageiosfera = () => {
        window.location.replace('/agradecimiento');
    }

    didGetErrorPaymen = (codigo, errortype, conekta, msg) => {
        alert(msg)
    }

    getPreRegistro = (params) => {
        this.props.post(
            "/preregistro",
            params,
            (response) => this.didPreRegisto(response),
            (error) => this.didGetErrorPreRegistro(error),
            cancelToken
        );
    }

    getProcode = (params) => {
        this.props.post(
            "/checkPromocode",
            params,
            (response) => this.didCheckPromocode(response),
            (error) => this.didGetErrorPrePromocode(error),
            cancelToken
        );
    }

    registarUsuariosFree = (params) => {
        this.props.post(
            "/paySummit",
            params,
            (response, msg) => this.didPayInvoice(response, msg),
            (codigo, errortype, conekta, msg) => {
                this.didGetError(codigo, errortype, conekta, msg);
            },
            cancelToken);
    }

    didPayInvoice = (response, msg) => {
        window.location.replace("/agradecimiento")
    }

    didGetError = (codigo, errortype, conekta, msg) => {
        $('#modal_colosepayment').click();
        alert(msg)
    }

    didCheckPromocode = (response) => {
        this.setState({ 
            porcentaje_summit: response.porcentaje_summit 
        });
        if(response.porcentaje_summit === "100"){
            this.setState({ 
                ispayfree: true
            })
            this.getcheckUserFree({
                token_id: this.props.getTokenId(),
                correo: this.state.correo
            });
        } else {
            this.getcheckUser({
                token_id: this.props.getTokenId(),
                correo: this.state.correo
            });
        }

    }

    didGetErrorPrePromocode = (error) => {
        this.setState({ porcentaje_summit: null });
        this.getcheckUser({
            token_id: this.props.getTokenId(),
            correo: this.state.correo
        });
    }

    didPreRegisto = (response) => {
        
    }

    didGetErrorPreRegistro = (error) => {
       
    }

    handlePromocodeChange = (event) => {

    }

    handleReturn = (event) => {
        this.setState({ is_pay: false });
    }

    handlePromocodeSubmit = (event) => {
        $('#modal_colosepaymentPromocode').click()
        $('#btnPayment').click()
    }

    handleSummit = (event) => {
        event.preventDefault();
        this.getProcode({
            token_id: this.props.getTokenId(),
            promocode: this.state.promoCode
        });
    }

    renderSummit = () => {
        return (
            <div className="summit-formulario">
                <div className="panel-body summit-panel">
                    <div className="panel panel-default">
                        <div className="panel-body text-left">
                            <Summit
                                ispayfree={this.state.ispayfree}
                                is_errorcheck={this.state.is_errorcheck}
                                nombre={this.state.nombre}
                                lastname={this.state.lastname}
                                correo={this.state.correo}
                                celular={this.state.celular}
                                edad={this.state.edad}
                                genero={this.state.genero}
                                ciudad={this.state.ciudad}
                                empresa={this.state.empresa}
                                tp_empresa={this.state.tipo_empresa}
                                puesto={this.state.puesto}
                                como_se_entero={this.state.como_se_entero}
                                como_se_entero_descrp={this.state.como_se_entero_descrp}
                                redSocial={this.state.redSocial}
                                busines={this.state.busines}
                                business={this.state.business}
                                estados={this.state.estados}
                                ciudades={this.state.ciudades}
                                estados_id={this.state.estados_id}
                                ciudad_id={this.state.ciudad_id}
                                promoCode={this.state.promoCode}
                                plan_id={this.state.plan_id}
                                isFree={this.state.isFree}
                                handleCuidadesListChange={this.handleCuidadesListChange}
                                handleChanegeName={this.handleChanegeName}
                                handleChanegeLastName={this.handleChanegeLastName}
                                handlebusinesChange={this.handlebusinesChange}
                                handleEstadosChange={this.handleEstadosChange}
                                handleChangeEvent={this.handleChangeEvent}
                                handlePlanChanged={this.handlePlanChanged}
                                handleChanegeevento_descrp={this.handleChanegeevento_descrp}
                                handleChangePuesto={this.handleChangePuesto}
                                handleChanegetp_empresa={this.handleChanegetp_empresa}
                                handleChanegeEmpresa={this.handleChanegeEmpresa}
                                handleChanegeCiudad={this.handleChanegeCiudad}
                                handleChanegeGenero={this.handleChanegeGenero}
                                handleChanegeEdad={this.handleChanegeEdad}
                                handleChanegeCelular={this.handleChanegeCelular}
                                handleChanegeCorreo={this.handleChanegeCorreo}
                                handleChangeSocial={this.handleChangeSocial}
                                handleChangePromocode={this.handleChangePromocode}
                                handleClearPromocode={this.handleClearPromocode}
                                handleSummit={this.handleSummit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPayment = () => {
        return (
            <div className="summit-formulario">
                <div className="panel-body summit-panel">
                    <div className="panel panel-default">
                        <div className="panel-body text-left">
                            <SummitPayment
                                nombre={this.state.nombre + ' ' + this.state.lastname}
                                correo={this.state.correo}
                                celular={this.state.celular}
                                centro_id={this.state.centro_id}
                                edad={this.state.edad}
                                genero={this.state.genero}
                                ciudad={this.state.ciudad ? this.state.ciudad : this.state.ciudad_id}
                                empresa={this.state.empresa}
                                tipo_empresa={this.state.tipo_empresa}
                                puesto={this.state.puesto}
                                como_se_entero={this.state.como_se_entero}
                                como_se_entero_descrp={this.state.como_se_entero_descrp}
                                redSocial={this.state.redSocial}
                                busines={this.state.busines}
                                business={this.state.business}
                                getTokenId={this.props.getTokenId}
                                promoCode={this.state.promoCode}
                                plan_id={this.state.plan_id}
                                centro_razonSocial={this.state.centro_razonSocial}
                                post={this.props.post}
                                handleReturn={this.handleReturn}
                                porcentaje_summit={this.state.porcentaje_summit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderPromocodeContainer = () => {
        return (
            <div className="summit-img">
                <div className="panel-body summit-panel">
                    <PromoCodeContainer
                        promoCode={this.state.promoCode}
                        porcentaje_summit={this.state.porcentaje_summit}
                        handleChangePromocode={this.handleChangePromocode}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="store-container summit-container">
                <div className={!this.state.is_pay ? "summit-container-forms" : "hidden"}>
                    <div className="simmit-forms">
                        {this.renderSummit()}
                    </div>
                    <div className="simmit-forms-img">
                        <div className="simmit-img"></div>
                    </div>
                </div>
                <div className={this.state.is_pay ? "summit-container-forms" : "hidden"}>
                    <div className="simmit-forms">
                        {this.renderPayment()}
                    </div>
                    <div className="simmit-forms-img" style={{ background: "var(--primary-dark)" }}>
                        {this.renderPromocodeContainer()}
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(SummitContainer);



// WEBPACK FOOTER //
// ./src/guest/summit/SummitContainer.js